import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4.055A9 9 0 1 0 19.945 12H12zM14 10V2.056A9 9 0 0 1 21.944 10z",
      clipRule: "evenodd"
    }
  )
);
var SvgAnalyticsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AnalyticsFilled_default = SvgAnalyticsFilled;

export { AnalyticsFilled_default as default };
